import React, { Component } from 'react';
import { Card, Icon, Form, Row, Col, Input, Select, Modal, Button } from 'antd';
import './Home.less';
import axios from '../../axios/appAxios';
import MyTask from '../Worklist/MyTask/MyTask'
import { intl } from '../../components/InilGlobalProvider/IntlGlobalProvider';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            announcement: {
                id: null,
                name: null,
                value: null
            },
            contact: {
                id: null,
                name: null,
                value: null
            }
        };
    }

    //----------------------------------------//
    // Init Function
    //----------------------------------------//
    componentDidMount = () => {
        this.fnGetAnnouncement();
    }

    //----------------------------------------//
    // Fn get Announcement
    //----------------------------------------//
    fnGetAnnouncement = () => {
        axios.get('/api/Management/HomeContent/All')
            .then(
                (response) => {
                    let announceData = response.data.find((item) => {
                        return item.name == "Announcement";
                    });
                    let contactData = response.data.find((item) => {
                        return item.name == "Contact";
                    });

                    this.setState({
                        announcement: announceData,
                        contact: contactData
                    });

                }, (error) => {
                    console.log(error);
                    Modal.error({
                        title: intl.msg({ id: 'modal.Error', defaultMessage: 'Error' }),
                        content: intl.msg({ id: 'modal.Error.content', defaultMessage: 'There is some error. Please try again later or contact admin to solve a problem.' }),
                    });
                });

    }
    //----------------------------------------//
    // Render
    //----------------------------------------//
    render() {
        return (
             
            <>
                <Row>
                    <Col sm={24} md={24} style={{ padding: '0 5px 5px 5px' }}>
                        <MyTask/>
                    </Col>
                </Row>
                <Row>
                    <Col sm={24} md={18} style={{ padding: '0 5px 5px 5px' }}>
                        <Card size="small" title={<h3>{intl.msg({ id: 'home.Announcement', defaultMessage: 'Announcement' })}</h3>} extra={null}>
                            <div id="Annoounce" dangerouslySetInnerHTML={{ __html: this.state.announcement.value }} style={{ minHeight: '250px',overflowY: 'auto'}}/>
                        </Card>
                    </Col>
                    <Col sm={24} md={6} style={{ padding: '0 5px 5px 5px' }}>
                        <Card size="small" title={<h3>{intl.msg({ id: 'home.Contact', defaultMessage: 'Contact' })}</h3>} extra={null}>
                            <div id="Annoounce" dangerouslySetInnerHTML={{ __html: this.state.contact.value }} style={{ minHeight: '250px', maxHeight: '250px', overflowY: 'auto' }} />
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }
}

export default Home;
